import { AbstractControl } from '@angular/forms';

export function EmailCompare(control: AbstractControl) {
  const email = control.get('email');
  const emailValue = email && email.value;

  const emailConfirmation = control.get('emailConfirmation');
  const emailConfirmationValue = emailConfirmation && emailConfirmation.value;

  if (!emailConfirmation || !emailConfirmation.value || !email || !email.value) {
    return {};
  }
  if (emailValue.toLowerCase() !== emailConfirmationValue.toLowerCase()) {
    return emailConfirmation.setErrors({ nomatch: true });
  } else {
    return emailConfirmation.setErrors(null);
  }
}

export const EmailRegExp =
  /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/i;
